// Thin sticky banner that calls out non-prod environments.
// Hidden on prod (returns null) so it adds nothing on app.yieldinnovations.com.
// Detection is by hostname — zero build config.

type Env = 'production' | 'uat' | 'local'

function detectEnv(): Env {
  if (typeof window === 'undefined') return 'production'
  const host = window.location.hostname
  if (host.startsWith('uat.')) return 'uat'
  if (host === 'localhost' || host === '127.0.0.1' || host.endsWith('.local')) return 'local'
  return 'production'
}

const configs: Record<Exclude<Env, 'production'>, { className: string; label: string }> = {
  uat: {
    className: 'bg-amber-500 text-white',
    label: 'UAT · Test Environment — data here is NOT real',
  },
  local: {
    className: 'bg-blue-600 text-white',
    label: 'LOCAL DEV',
  },
}

export default function EnvBanner() {
  const env = detectEnv()
  if (env === 'production') return null

  const { className, label } = configs[env]
  return (
    <div
      className={`${className} text-[11px] font-semibold uppercase tracking-wider px-4 py-1 text-center sticky top-0 z-[100] select-none`}
      role="status"
      aria-label={`Environment: ${env}`}
    >
      {label}
    </div>
  )
}
